import { InjectionToken } from '@angular/core';
import { AnalyticsAdapter, AnalyticsProperties } from './analytics.types';

export class NoopAnalyticsAdapter implements AnalyticsAdapter {
  public track(event: string, properties?: AnalyticsProperties): void {
    void event;
    void properties;
  }

  public identify(userId: string): void {
    void userId;
  }

  public setContext(properties: AnalyticsProperties): void {
    void properties;
  }

  public reset(): void {
    return;
  }
}

export const ANALYTICS_ADAPTER = new InjectionToken<AnalyticsAdapter>(
  'ANALYTICS_ADAPTER',
  {
    providedIn: 'root',
    factory: () => new NoopAnalyticsAdapter(),
  },
);
